import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { ROUTES } from '../constants/RouteNameMapping';

const routesWithAdditionalNav = new Set([
  ROUTES.PORTFOLIO,
  ROUTES.DEAL_FLOW,
  ROUTES.KPI,
  ROUTES.COMPANIES,
  ROUTES.ADMIN_PANEL,
  ROUTES.FINANCE2,
  ROUTES.SOURCING,
  ROUTES.ENTITIES,
]);

export function useHasAdditionalNav() {
  const { pathname } = useLocation();

  return useMemo(() => {
    const loc = pathname.split('/')[1];
    return routesWithAdditionalNav.has(loc as ROUTES);
  }, [pathname]);
}
